import { render, staticRenderFns } from "./the-most-popular-home.vue?vue&type=template&id=3f75aafd&scoped=true"
import script from "./the-most-popular-home.vue?vue&type=script&lang=js"
export * from "./the-most-popular-home.vue?vue&type=script&lang=js"
import style0 from "./the-most-popular-home.vue?vue&type=style&index=0&id=3f75aafd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f75aafd",
  null
  
)

export default component.exports